import React from 'react';
import '../styles/InvoiceTable.css';

const InvoiceTable = ({ items, onRemoveItem, onRowKeyDown }) => {
  return (
    <div className="table-wrapper">
      <table className="invoice-table">
        <thead>
          <tr>
            <th>Item</th>
            <th className="text-center">Qty</th>
            <th className="text-right">Price</th>
            <th className="text-right">Amount</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr
              key={index}
              data-index={index}
              tabIndex={0}
              onKeyDown={(e) => onRowKeyDown(e, index)}
            >
              <td className="item-name">{item.name}</td>
              <td className="text-center">{item.qty}</td>
              <td className="text-right">{item.price}</td>
              <td className="text-right amount">{item.amount}</td>
              <td className="text-center">
                <button
                  onClick={() => onRemoveItem(index)}
                  className="btn-remove"
                  title="Remove item"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                    <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3 10.5a.75.75 0 0 0 0-1.5H9a.75.75 0 0 0 0 1.5h6Z" clipRule="evenodd" />
                  </svg>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceTable;